import { Route, Routes } from 'react-router-dom'
import { constants, links, paths } from 'apps'
import { CommonLayout } from 'layouts'
import { PrivateRoute } from 'routes'
import { useEffect } from 'react'
import { handleAsyncRequest } from 'utils/helper'
import { getSignerByProvider } from 'utils/metamask'
import { useAppSelector, useLocalStorage } from 'hooks'
import ShopMain from './pages/Main'
import { BuyItems, InventoryItems, ItemDetails, ItemInventoryDetails, SellItems, ItemSellingDetails } from './pages'
import { useAvailableWallet } from 'features/Auth/pages/Main/useAvailableWallet'

function Shop() {
  const [, setUserId] = useLocalStorage(constants.USER_ID_KEY, 0)
  const [, setAccessToken] = useLocalStorage(constants.ACCESS_TOKEN_KEY, null)
  const [, setRefreshToken] = useLocalStorage(constants.REFRESH_TOKEN_KEY, null)
  const auth = useAppSelector(state => state.auth)
  const providers = useAvailableWallet();
  const storedWalletName = localStorage.getItem("walletName");

  const matchedProviderDetail = providers.find(
    (p) => p.info.name === storedWalletName
  );
  const ethereumProvider = matchedProviderDetail?.provider ?? window.ethereum;

  const checkSignerProfile = async () => {
    const [signerError] = await handleAsyncRequest(getSignerByProvider(ethereumProvider))
    if (signerError) {
      setUserId(0)
      setAccessToken('')
      setRefreshToken('')
    }
  }
  useEffect(() => {
    if (providers?.length) {
      checkSignerProfile()
    }
  }, [providers])
  return (
    <Routes>
      <Route
        path={paths.default()}
        element={
          <PrivateRoute isLogged={auth.isLogged} layout={CommonLayout} navigate={links.home.index()}>
            <ShopMain />
          </PrivateRoute>
        }
      >
        <Route path={paths.shop.buyItems()} element={<BuyItems />} />
        <Route path={paths.shop.inventoryItems()} element={<InventoryItems />} />
        <Route path={paths.shop.sellItems()} element={<SellItems />} />
        <Route path={paths.shop.buyItemsDetails()} element={<ItemDetails />} />
        <Route path={paths.shop.inventoryItemsDetails()} element={<ItemInventoryDetails />} />
        <Route path={paths.shop.sellItemsDetails()} element={<ItemSellingDetails />} />
      </Route>
      {/* <Route path='*' element={<Navigate replace to={paths.notFound.feature()} />} /> */}
    </Routes>
  )
}

export default Shop
